const formats = new Map<string, Intl.NumberFormat>()

/** Cents as money in `locale`: `formatMoney(28240, 'EUR', 'en-GB')` is "€282.40". */
export function formatMoney(cents: number, currency: string, locale: string): string {
  const key = `${locale}|${currency}`
  let format = formats.get(key)
  if (!format) {
    format = new Intl.NumberFormat(locale, { style: 'currency', currency })
    formats.set(key, format)
  }
  return format.format(cents / 100)
}
